import { useQuery } from 'react-query'

import { API_URL } from 'src/constants'

export function useGetPage(lang: string, slug: string) {
    return useQuery(slug, () =>
        fetch(`${API_URL}/page/${slug}?lang=${lang}`).then((res) => res.json())
    )
}
